import { render, staticRenderFns } from "./NotificationEmails.vue?vue&type=template&id=5b101528&scoped=true&"
import script from "./NotificationEmails.vue?vue&type=script&lang=js&"
export * from "./NotificationEmails.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEmails.vue?vue&type=style&index=0&id=5b101528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b101528",
  null
  
)

export default component.exports